module.exports = __webpack_public_path__ + "65d884b8735766a2559c7abfa6398b46.png";